import Paper from "@mui/material/Paper";
import { styled } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import { grey } from "@mui/material/colors";
import Slider_lenta from "../../elements/slider/slider";
import parse from "html-react-parser";
import "./Lenta_card.css";

const Item = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(0),
  margin: 0,
  textAlign: "center",
}));

const Lenta_text = styled(Typography)(({ theme }) => ({
  padding: theme.spacing(0),
  margin: 0,
  textAlign: "center",
  color: grey[400],
  fontSize: "0.9rem",
  fontFamily: "Roboto",
  border: "1px",
}));

export default function LentaCardApp({ e }) {
  return (
    <div className="card">
      <Item elevation={12}>
        <Typography variant="h6" gutterBottom>
          {e.title}
        </Typography>
        <Slider_lenta data={e.anti} />
        <Box sx={{ m: { xs: 2, sm: 3, lg: 3 } }}>
          <Typography variant="body1" gutterBottom>
            {parse(e.content)}
          </Typography>
        </Box>
        <Stack direction="row" spacing={2} justifyContent="space-around">
          <Box></Box>
          <Box></Box>
          <Box></Box>
          <Box className="zoom-effect">
            <Lenta_text>{e.time_create}</Lenta_text>
          </Box>
        </Stack>
      </Item>
    </div>
  );
}
